import { EMPTY_FUNCTION } from '../../../../constants/common'
import { FileAttachTag, FileList } from '../../../File'

import * as styles from './ChatroomMessageEditFormFiles.module.css'

function ChatroomMessageEditFormFiles({
  errorItems,
  files,
  isSubmitting,
  uploadingItems,
  onRemoveFileTag,
}) {
  function renderFile(file, key) {
    return (
      <FileAttachTag
        file={file}
        isDisabled={isSubmitting}
        key={key}
        onClick={EMPTY_FUNCTION}
        onRemove={onRemoveFileTag}
      />
    )
  }

  return (
    <FileList
      className={styles.chatroomMessageEditFormFiles}
      errorItems={errorItems}
      files={files}
      itemClassName={styles.item}
      renderItem={renderFile}
      uploadingItems={uploadingItems}
    />
  )
}

export default ChatroomMessageEditFormFiles
